import React from "react";
import { useNavigate } from "react-router-dom";
import { logoutAdmin } from "../../utils/auth";
import "../css/Topbar.css";

export default function Topbar({ title, searchValue, onSearchChange, placeholder, isMobile, onMenuClick }) {
  const navigate = useNavigate();

  return (
    <div className="admin-topbar">

      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        {isMobile && (
          <button
            className="hamburger-btn"
            onClick={onMenuClick}
            aria-label="Toggle menu"
          >
            <span />
            <span />
            <span />
          </button>
        )}
        <h1 style={{ margin: 0 }}>{title}</h1>
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        {!isMobile && (
          <input
            type="text"
            placeholder={placeholder || "Search..."}
            value={searchValue}
            onChange={onSearchChange}
            className="top-search"
          />
        )}
        <button
          className="logout-btn"
          onClick={() => { logoutAdmin(); navigate("/login", { replace: true }); }}
        >
          {isMobile ? "⏏" : "Logout"}
        </button>
      </div>

      {/* Search below title on mobile */}
      {isMobile && (
        <div style={{ width: "100%", marginTop: 8 }}>
          <input
            type="text"
            placeholder={placeholder || "Search..."}
            value={searchValue}
            onChange={onSearchChange}
            className="top-search"
            style={{ width: "100%", boxSizing: "border-box" }}
          />
        </div>
      )}

    </div>
  );
}